const detailPaths: Record<string, string[]> = {
  "smartstore.naver.com": ["/"],
  "m.smartstore.naver.com": ["/"],
  "itempage3.auction.co.kr": ["/DetailView.aspx"],
  "itempage.auction.co.kr": ["/DetailView.aspx"],
  "mitem.auction.co.kr": ["/vip"],
  "www.gmarket.co.kr": ["/n/search", "/Item"],
  "item.gmarket.co.kr": ["/Item"],
  "m.gmarket.co.kr": ["/vi/product/"],
  "www.11st.co.kr": ["/products/"],
  "m.11st.co.kr": ["/products/"],
  "www.coupang.com": ["/vp/products/"],
  "coupang.com": ["/vp/products/"],
  "www.ssg.com": ["/item/itemView.ssg"],
  "emart.ssg.com": ["/item/itemView.ssg"],
  "shinsegaemall.ssg.com": ["/item/itemView.ssg"],
  "www.29cm.co.kr": ["/products/"],
  "29cm.co.kr": ["/products/"],
  "www.musinsa.com": ["/products/"],
  "musinsa.com": ["/products/"],
  "www.kurly.com": ["/goods/"],
  "kurly.com": ["/goods/"],
  "www.wconcept.co.kr": ["/Product/"],
  "wconcept.co.kr": ["/Product/"],
  "www.fashionplus.co.kr": ["/goods/detail/"],
  "fashionplus.co.kr": ["/goods/detail/"],
  "www.lotteon.com": ["/p/product/"],
  "www.lotteimall.com": ["/goods/"],
  "www.nsmall.com": ["/goods"],
  "www.skstoa.com": ["/display/goods"],
  "www.hmall.com": ["/md/pda/itemPtc"],
  "www.compuzone.co.kr": ["/product/product_detail.htm"],
  "www.shinsegaetvshopping.com": ["/display/detail"],
};

export function isDirectCompareItemUrl(value: string, allowBridge = true): boolean {
  if (value !== value.trim() || value.length > 2000) return false;
  try {
    const url = new URL(value);
    if (!/^https?:$/.test(url.protocol) || url.username || url.password ||
      (url.port && !["80", "443"].includes(url.port))) return false;
    const host = url.hostname.toLowerCase();
    const path = url.pathname;
    if (host === "cr.shopping.naver.com") {
      return allowBridge && path.startsWith("/adcr") && !!url.searchParams.get("nvMid");
    }
    if (host === "prod.danawa.com") {
      return allowBridge && path === "/bridge/loadingBridge.html" &&
        !!url.searchParams.get("cmpnyc") && !!url.searchParams.get("link_pcode");
    }
    if (host === "www.enuri.com") {
      return allowBridge && path === "/move/Redirect.jsp" && !!url.searchParams.get("pl_no");
    }
    if (["smartstore.naver.com", "m.smartstore.naver.com"].includes(host)) {
      return /^\/[^/]+\/products\/\d+\/?$/.test(path);
    }
    if (["www.coupang.com", "coupang.com"].includes(host)) {
      return /^\/vp\/products\/\d+\/?$/.test(path);
    }
    if (["www.29cm.co.kr", "29cm.co.kr", "www.musinsa.com", "musinsa.com"].includes(host)) {
      return /^\/products\/\d+\/?$/.test(path);
    }
    if (["www.kurly.com", "kurly.com"].includes(host)) {
      return /^\/goods\/\d+\/?$/.test(path);
    }
    if (["www.wconcept.co.kr", "wconcept.co.kr"].includes(host)) {
      return /^\/Product\/\d+\/?$/.test(path);
    }
    if (["www.fashionplus.co.kr", "fashionplus.co.kr"].includes(host)) {
      return /^\/goods\/detail\/\d+\/?$/.test(path);
    }
    if (detailPaths[host]?.some((prefix) => path.startsWith(prefix))) return true;
    return (/^[a-z0-9-]+\.godomall\.com$/i.test(host) && path === "/goods/goods_view.php") ||
      (/^[a-z0-9-]+\.cafe24\.com$/i.test(host) && path.startsWith("/product/")) ||
      (["mobile.a-bly.com", "m.a-bly.com"].includes(host) && path.startsWith("/goods/")) ||
      (host === "4910.kr" && path.startsWith("/desktop/goods/")) ||
      (["zigzag.kr", "www.zigzag.kr"].includes(host) && path.startsWith("/app/catalog/products/"));
  } catch { return false; }
}

export function getDirectMyItemUrl(
  shop: { market_site: string; url?: string } | null | undefined,
  shopItemId: string,
): string {
  const itemId = encodeURIComponent(shopItemId.trim());
  if (!shop || !itemId) return "";
  let url = "";
  switch (shop.market_site) {
    case "smartstore":
      if (shop.url) url = `${shop.url.replace(/\/+$/, "")}/products/${itemId}`;
      break;
    case "auction":
      url = `https://itempage.auction.co.kr/DetailView.aspx?itemno=${itemId}`;
      break;
    case "gmarket":
      url = `https://item.gmarket.co.kr/Item?goodscode=${itemId}`;
      break;
    case "eleventh":
      url = `https://www.11st.co.kr/products/${itemId}`;
      break;
    case "ssgdotcom":
      url = `https://www.ssg.com/item/itemView.ssg?itemId=${itemId}`;
      break;
    case "lotteon":
      url = `https://www.lotteon.com/p/product/${itemId}`;
      break;
  }
  return isDirectCompareItemUrl(url, false) ? url : "";
}
